import React from 'react'
import { Providers } from "./providers";
import 'react-photo-view/dist/react-photo-view.css';
import { queryClient } from '@shared/api/query-client';
import 'react-tooltip/dist/react-tooltip.css'
import './styles/toast.scss';
import './styles/photo-view.scss';
import './styles/index.scss'

export const App = () => <Providers client={queryClient}/>